import { useConversationsStore } from '@/stores/conversations/conversations.store';
import type { ConversationType } from '@/types/conversation.types';
import type { AiStatus } from '@/types/events/ai-status-update';

export default function aiStatusUpdate(data: AiStatus): void {
  const conversationsStore = useConversationsStore();

  conversationsStore.updateOrInsertConversation(data.conversationData);

  if ((conversationsStore.activeConversation as ConversationType)?.conversationId === data.conversationId) {
    conversationsStore.updateActiveConversation(data.conversationData);
  }
}
